// Pure DOM-update functions driven entirely by the cart JSON Shopify just
// returned — no client-side price prediction, no HTML string parsing, no
// diffing of two trees. Every number on screen traces back to one real
// server response. Unaffected rows/elements are never touched.
window.FlixCartRender = (function () {
  // Shopify's own money_format token algorithm (the same one Dawn ships in
  // global.js) — implemented directly rather than depending on
  // window.Shopify.formatMoney, which historically required a theme to
  // separately load option_selection.js and isn't guaranteed present.
  function formatWithDelimiters(cents, precision, thousands, decimalSep) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimalSep = decimalSep == null ? '.' : decimalSep;
    if (isNaN(cents) || cents == null) return '0';
    var amount = (cents / 100).toFixed(precision);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? dollars + decimalSep + parts[1] : dollars;
  }

  function formatMoney(cents) {
    var format = window.flixMoneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(match[0], value);
  }

  function root() {
    return document.getElementById('flix-cart-drawer-root');
  }

  function fillRow(row, item) {
    row.dataset.key = item.key;
    var img = row.querySelector('[data-flix-cart-line-img]');
    if (img) {
      if (item.image) {
        img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=132';
        img.alt = item.product_title || item.title || '';
        img.style.display = '';
      } else {
        img.style.display = 'none';
      }
    }
    var title = row.querySelector('[data-flix-cart-line-title]');
    if (title) title.textContent = item.product_title || item.title || '';
    var type = row.querySelector('[data-flix-cart-line-type]');
    if (type) type.textContent = item.product_type || '';
    var qty = row.querySelector('[data-flix-cart-line-qty]');
    if (qty) qty.textContent = item.quantity;
    var price = row.querySelector('[data-flix-cart-line-price]');
    if (price) price.textContent = formatMoney(item.final_line_price);
    row.querySelectorAll('[data-flix-cart-qty-inc],[data-flix-cart-qty-dec],[data-flix-cart-remove]').forEach(function (btn) {
      btn.dataset.key = item.key;
    });
  }

  function reconcileLines(cart) {
    var r = root();
    var list = r && r.querySelector('[data-flix-cart-items]');
    var template = r && r.querySelector('[data-flix-cart-row-template]');
    if (!list || !template) return;

    var existingByKey = {};
    list.querySelectorAll('[data-flix-cart-line]').forEach(function (row) {
      existingByKey[row.dataset.key] = row;
    });

    var keep = {};
    cart.items.forEach(function (item) {
      keep[item.key] = true;
      var row = existingByKey[item.key];
      if (!row) {
        row = template.content.firstElementChild.cloneNode(true);
        list.appendChild(row);
      } else {
        list.appendChild(row); // reuse the existing node — keeps image/listeners, just reorders if needed
      }
      fillRow(row, item);
    });

    Object.keys(existingByKey).forEach(function (key) {
      if (!keep[key]) existingByKey[key].remove();
    });
  }

  function renderCart(cart) {
    var r = root();
    if (!r) return;

    // Real Arabic/English pluralization only happens server-side (Liquid's
    // `t` filter). `data-count-template` was rendered once with count=100 —
    // a number that always lands in the catch-all "other" form for both
    // locales' plural rules — so swapping "100" for the live count keeps
    // correct grammar for every count except exactly 1 or 2, where the
    // phrasing reverts to the generic form until the next full page load.
    // A deliberate, minor cosmetic trade-off rather than shipping a
    // plural-rules engine for one subtitle line.
    var subtitle = r.querySelector('[data-flix-cart-subtitle]');
    if (subtitle && r.dataset.countTemplate) {
      subtitle.textContent = r.dataset.countTemplate.replace('100', cart.item_count);
      subtitle.dataset.count = cart.item_count;
    }

    var empty = r.querySelector('[data-flix-cart-empty]');
    var filled = r.querySelector('[data-flix-cart-filled]');
    if (cart.item_count === 0) {
      if (empty) empty.hidden = false;
      if (filled) filled.hidden = true;
    } else {
      if (empty) empty.hidden = true;
      if (filled) filled.hidden = false;
      reconcileLines(cart);
    }

    var total = r.querySelector('[data-flix-cart-total]');
    if (total) {
      total.textContent = formatMoney(cart.total_price);
      total.dataset.cents = cart.total_price;
    }

    document.dispatchEvent(new CustomEvent('flix:cart:count', { detail: { count: cart.item_count } }));
  }

  return { renderCart: renderCart, formatMoney: formatMoney };
})();
